import React from 'react';
import SignupContainer from 'containers/SignupContainer/SignupContainer'

export default function SignupPage() {
    return (
        <SignupContainer />
    )
}
